<template>
  <div class="mt-4">
    <v-layout>
      <v-flex>
        <v-btn flat @click="handleGoBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="primary" @click="handleDownloadTemplate">
          <em class="fas fa-download" />&nbsp;&nbsp;{{ $t('download_template') }}
        </v-btn>
        <ImportXLSX :loading="importLoading" @onChange="handleImportTemplate"></ImportXLSX>
      </v-flex>
    </v-layout>

    <v-container>
      <h3 class="headline">{{ $t('Add new broadcast') }}</h3>
    </v-container>

    <v-container>
      <div>{{ $t('Broadcast Name') }}</div>
      <div class="form-control" :class="{ 'has-error': errors.has('broadcastName') }">
        <input
          v-model="name"
          v-validate="'required'"
          type="text"
          class="form-control"
          name="broadcastName"
          data-vv-name="broadcastName"
          :data-vv-as="$t('Broadcast Name')"
          :placeholder="$t('Broadcast Name')"
        />
        <span v-show="errors.has('broadcastName')" class="text-error">{{
          errors.first('broadcastName')
        }}</span>
      </div>
      <v-flex class="text-xs-right">
        <v-btn outline color="primary" @click="isAddConfigDialog = true">
          <em class="fas fa-plus" />&nbsp;&nbsp;{{ $t('add_mobile_number') }}
        </v-btn>
      </v-flex>
      <v-layout class="mt-4">
        <v-data-table
          :headers="headers"
          :items="displayRows"
          class="elevation-1"
          hide-actions
          style="width: 100%"
        >
          <template #items="props">
            <td>{{ props.item.mobile }}</td>
            <td>{{ props.item.value1 }}</td>
            <td>{{ props.item.value2 }}</td>
            <td>{{ props.item.value3 }}</td>
            <td>
              <v-btn color="grey" outline @click="handleDelete(props.index)">{{
                $t('Delete')
              }}</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-layout>
      <v-layout class="mt-2" style="display: flex; justify-content: flex-end">
        <v-pagination v-model="page" :length="pageLength" :total-visible="7" />
      </v-layout>
      <v-layout column class="mt-4">
        <IntentGroup
          v-model="messages"
          :has-alternative="false"
          :is-welcome="true"
          :available-bubbles="availableBubbles"
          :max-intent="5"
        ></IntentGroup>
      </v-layout>
      <v-layout class="mt-4">
        <v-flex>{{ $t('Schedule Broadcast') }}</v-flex>
        <v-flex class="text-xs-right">
          <label class="toggle-switch small" style="vertical-align: bottom">
            <input type="checkbox" :checked="isSchedule" @change="handleOnBroadcastSchedule" />
            <span class="toggle-slider lever round"></span>
          </label>
        </v-flex>
      </v-layout>
      <v-layout v-if="isSchedule" wrap>
        <v-flex xs6 class="form-control">
          <v-layout wrap>
            <v-flex xs8>
              <v-menu
                ref="showScheduleDate"
                v-model="showScheduleDate"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template #activator="{ on }">
                  <input id v-model="scheduleDate" type="text" name readonly v-on="on" />
                </template>
                <v-date-picker
                  v-model="scheduleDate"
                  color="primary"
                  @input="showScheduleDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="pl-1">
              <v-menu
                ref="showScheduleTime"
                v-model="showScheduleTime"
                :close-on-content-click="false"
                :return-value.sync="scheduleTime"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template #activator="{ on }">
                  <input id v-model="scheduleTime" type="text" name readonly v-on="on" />
                </template>
                <v-time-picker
                  v-if="showScheduleTime"
                  v-model="scheduleTime"
                  full-width
                  color="primary"
                  :allowed-minutes="allowedStep"
                  @click:minute="$refs.showScheduleTime.save(scheduleTime)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="text-xs-center mt-2">
        <v-btn color="grey" outline @click="handleGoBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
        <v-btn color="grey" outline @click="handleSentBroadcast('draft')">
          <i class="fas fa-save mr-1"></i>
          {{ $t('save_draft') }}
        </v-btn>
        <v-btn depressed color="primary" @click="handleSentBroadcast('sent')">
          <i class="fas fa-paper-plane mr-1"></i>
          {{ $t('Send') }}
        </v-btn>
      </div>
    </v-container>
    <!-- Section Add Config -->
    <v-dialog v-model="isAddConfigDialog" max-width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="isAddConfigDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-flex class="pa-3 mx-3">
          <div>
            <div>{{ $t('mobile') }}</div>
            <div class="form-control" :class="{ 'has-error': errors.has('mobile') }">
              <input
                v-model="payload.mobile"
                v-validate="'required'"
                type="text"
                class="form-control"
                name="mobile"
                data-vv-name="mobile"
                :data-vv-as="$t('mobile')"
                :placeholder="$t('mobile')"
                :maxlength="10"
              />
              <span v-show="errors.has('mobile')" class="text-error">{{
                errors.first('mobile')
              }}</span>
            </div>
          </div>
          <div>
            <div>{{ $t('value1') }}</div>
            <div class="form-control" :class="{ 'has-error': errors.has('value1') }">
              <input
                v-model="payload.value1"
                v-validate="'required'"
                type="text"
                class="form-control"
                name="value1"
                data-vv-name="value1"
                :data-vv-as="$t('value1')"
                :placeholder="$t('value1')"
              />
              <span v-show="errors.has('value1')" class="text-error">{{
                errors.first('value1')
              }}</span>
            </div>
          </div>
          <div>
            <div>{{ $t('value2') }}</div>
            <div class="form-control" :class="{ 'has-error': errors.has('value2') }">
              <input
                v-model="payload.value2"
                type="text"
                class="form-control"
                name="value1"
                data-vv-name="value2"
                :data-vv-as="$t('value2')"
                :placeholder="$t('value2')"
              />
              <span v-show="errors.has('value2')" class="text-error">{{
                errors.first('value2')
              }}</span>
            </div>
          </div>
          <div>
            <div>{{ $t('value3') }}</div>
            <div class="form-control" :class="{ 'has-error': errors.has('value3') }">
              <input
                v-model="payload.value3"
                type="text"
                class="form-control"
                name="value3"
                data-vv-name="value3"
                :data-vv-as="$t('value3')"
                :placeholder="$t('value3')"
              />
              <span v-show="errors.has('value3')" class="text-error">{{
                errors.first('value3')
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline @click="isAddConfigDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" @click="handleSubmit">
            {{ $t('Save') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import dayjs from 'dayjs'
import ImportXLSX from '@/components/elements/importxlsx'
import IntentGroup from '@/components/view/intent/IntentGroup'
export default {
  components: {
    ImportXLSX,
    IntentGroup
  },
  data() {
    return {
      importLoading: false,
      name: `Broadcast_${dayjs().format('YYYY_MM_DD_HH_mm_ss')}`,
      isSchedule: false,
      showScheduleDate: false,
      showScheduleTime: false,
      scheduleDate: dayjs().format('YYYY-MM-DD'),
      scheduleTime: dayjs().format('HH:mm'),
      isAddConfigDialog: false,
      payload: {
        mobile: '',
        value1: '',
        value2: '',
        value3: ''
      },
      list: [],
      messages: [[]],
      availableBubbles: ['line_flex'],
      broadcastId: null,
      page: 1,
      limit: 20
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    headers() {
      return [
        { text: 'Mobile.', value: 'mobile', sortable: false },
        { text: 'Value1', value: 'value1', sortable: false },
        { text: 'Value2', value: 'value2', sortable: false },
        { text: 'Value3', value: 'value3', sortable: false },
        { text: '', value: '', sortable: false }
      ]
    },
    pageLength() {
      if (this.list.length) {
        return Math.ceil(this.list.length / this.limit)
      } else {
        return 1
      }
    },
    displayRows() {
      const startIndex = (this.page - 1) * this.limit
      const endIndex = startIndex + this.limit
      return this.list.slice(startIndex, endIndex)
    },
    flexMessage() {
      const message = this.messages[0]
      return message.map((item) => {
        return {
          ...item,
          contents: JSON.parse(item.contents)
        }
      })
    }
  },
  methods: {
    handleGoBack() {
      this.$emit('go-back')
    },
    handleDownloadTemplate() {
      const heading = [['mobile', 'value1', 'value2', 'value3']]
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `lon-broadcast_template.xlsx`)
    },
    handleImportTemplate(item) {
      if (item.length <= 0) return

      try {
        const pushedItem = item[0].map(
          ({ mobile = '', value1 = '', value2 = '', value3 = '' }) => ({
            mobile,
            value1,
            value2,
            value3
          })
        )

        this.list.push(...pushedItem)
      } catch (error) {
        this.$swal.fire({
          title: this.$t('invalid_data'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      }
    },
    async handleSubmit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return false
      }
      this.list.push(this.payload)
      this.isAddConfigDialog = false
      this.payload = {
        mobile: '',
        value1: '',
        value2: '',
        value3: ''
      }
    },
    handleDelete(index) {
      if (index > -1) this.list.splice(index, 1)
    },
    handleOnBroadcastSchedule() {
      this.isSchedule = !this.isSchedule
    },
    async handleSentBroadcast(status = 'draft') {
      const response = await this.$swal.fire({
        title: this.$t(
          status == 'draft'
            ? 'Do you want to draft broadcast {name}?'
            : 'Do you want to broadcast {name}?',
          {
            name: this.name
          }
        ),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (response.value) {
        const payload = {
          id: this.broadcastId,
          page_id: this.selectedBot.pageid,
          messages: this.flexMessage || [],
          phone_number_list: this.list || [],
          delivery_tag: this.name,
          status: status,
          schedule_timestamp:
            this.scheduleDate && this.scheduleTime && this.isSchedule
              ? `${this.scheduleDate} ${this.scheduleTime}`
              : null
        }
        if (
          payload.messages.length <= 0 ||
          payload.phone_number_list.length <= 0 ||
          this.errors.first('broadcastName')
        ) {
          this.$swal.fire({
            title: this.$t('invalid_data'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
          return
        }
        if (!payload.id) {
          delete payload.id
        }
        this.$emit('submit', payload)
      }
    },
    handleFillForm(broadcast) {
      this.broadcastId = broadcast.id
      this.name = broadcast.delivery_tag
      this.isSchedule = !!broadcast.schedule_timestamp
      if (broadcast.schedule_timestamp) {
        this.scheduleDate = dayjs(broadcast.schedule_timestamp).format('YYYY-MM-DD')
        this.scheduleTime = dayjs(broadcast.schedule_timestamp).format('HH:mm')
      }
      this.list = broadcast.phone_number_list
      const flexMessage = broadcast.messages.map((item) => {
        return {
          ...item,
          contents: JSON.stringify(item.contents)
        }
      })
      this.messages[0].push(...flexMessage)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastManage.vue